import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
import RegularTitle from '~/components/atoms/Global/RegularTitle.vue';
import RegularSubtitle from '~/components/atoms/Global/RegularSubtitle.vue';
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
import CollapsablePanel from '~/components/molecules/CollapsablePanel.vue';
export default {
  name: 'ReassuranceCards',
  components: {
    RegularTitle: RegularTitle,
    RegularSubtitle: RegularSubtitle,
    SimpleParagraph: SimpleParagraph,
    CollapsablePanel: CollapsablePanel
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      isFolded: true
    };
  },
  computed: {
    currentPayload: function currentPayload() {
      var _ref13, _ref14, _ref15;

      return {
        title: ((_ref15 = this.payload) != null ? (_ref15 = _ref15.primary) != null ? _ref15.title : _ref15 : _ref15) || [],
        subtitle: ((_ref14 = this.payload) != null ? (_ref14 = _ref14.primary) != null ? _ref14.subtitle : _ref14 : _ref14) || [],
        background: ((_ref13 = this.payload) != null ? (_ref13 = _ref13.primary) != null ? _ref13.background_color : _ref13 : _ref13) || '#f8f9fa',
        cards: this.payload.items.map(function (i) {
          var _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12;

          return {
            image: {
              small: formatPrismicImage((_ref12 = i) != null ? (_ref12 = _ref12.image) != null ? _ref12.url : _ref12 : _ref12, ['w_375']) || EMPTY_PIXEL,
              medium: formatPrismicImage((_ref11 = i) != null ? (_ref11 = _ref11.image) != null ? _ref11.url : _ref11 : _ref11, ['w_375,dpr_2']) || EMPTY_PIXEL,
              large: formatPrismicImage((_ref10 = i) != null ? (_ref10 = _ref10.image) != null ? _ref10.url : _ref10 : _ref10, ['w_1440']) || EMPTY_PIXEL,
              xlarge: formatPrismicImage((_ref9 = i) != null ? (_ref9 = _ref9.image) != null ? _ref9.url : _ref9 : _ref9, ['w_1440,dpr_2']) || EMPTY_PIXEL
            },
            textColor: ((_ref8 = i) != null ? _ref8.text_color : _ref8) || '',
            title: ((_ref7 = i) != null ? _ref7.title : _ref7) || {},
            paragraph: ((_ref6 = i) != null ? _ref6.paragraph : _ref6) || '',
            cta: ((_ref5 = i) != null ? _ref5.cta : _ref5) || '',
            url: ((_ref4 = i) != null ? (_ref4 = _ref4.url) != null ? _ref4.url : _ref4 : _ref4) || '',
            tracking: {
              data: {
                event_category: ((_ref3 = i) != null ? _ref3.event_category1 : _ref3) || '',
                event_action: ((_ref2 = i) != null ? _ref2.event_action1 : _ref2) || '',
                event_label: ((_ref = i) != null ? _ref.event_label1 : _ref) || ''
              }
            }
          };
        })
      };
    }
  }
};